import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    Button,
    DialogTitle,
} from '@mui/material';
import { DataTable, Loadable } from '../../../../common';
import { getImportableNPIs } from '../../../../store/api/facilities';
import { useData } from '@pure-ptr/react';
import {
    Portlet,
    PortletBody,
    PortletHeader,
    PortletHeaderToolbar,
} from "../../../../partials/content/Portlet";
import { nonPaginatedSorting } from '../../../../util';

export default function ImportNPIDialog({ 
    open, onClose, onImport, existingNpis = [], 
    fields, selectedItems, pageName, actions 
}) {
    const [tableConfig, setTableConfig] = useState({ data: [], sort: [] });
    
    const { data: npis, isPending } = useData(async () => {
        if (open) {
            const data = await getImportableNPIs();
            const npisData= data?.map(item => ({
                ...item,
                id: item.billingProviderNPI + (item.providerCCN || '')
            })) || [];

        setTableConfig({ ...tableConfig, data: [...(npisData || [])] });
        return npisData

        }
        return [];
    }, [open]);

    useEffect(() => {
        if (open && existingNpis.length > 0 && npis?.length > 0) {
            const initialSelected = npis
                .filter(row => existingNpis.some(e => e.billingProviderNPI === row.billingProviderNPI && e.providerCCN === row.providerCCN))
                .map(row => row.id);
            
            if (initialSelected.length > 0) {
                actions.setCheckboxSelected(initialSelected);
            }
        } else if (open) {
            actions.setCheckboxSelected([]);
        }
    }, [open, npis]);

    const handleImport = () => {
        const selectedRows = npis?.filter(row => selectedItems.includes(row.id));
        onImport(selectedRows || []);
        onClose();
    };

    const handleSort = (sort) => {
            let data = [...(tableConfig?.data || [])];
            const { sort: tSort, tableData: sortedTableData } = nonPaginatedSorting(
                sort,
                [...data]
            );
            setTableConfig({ sort: tSort, data: sortedTableData });
            return sortedTableData;
        };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>IMPORT NPIs</DialogTitle>
            <DialogContent dividers sx={{ p: 0 }}>
                <Portlet>
                    <PortletHeader 
                        title="Import NPIs"
                        toolbar={
                            <PortletHeaderToolbar>
                                {/* Standard toolbar if needed */}
                            </PortletHeaderToolbar>
                        }
                    />
                    <PortletBody>
                        <div style={{ minHeight: 300 }}>
                            <Loadable loading={!!isPending}>
                                <DataTable
                                    pageName={pageName}
                                    data={tableConfig?.data || []}
                                        onSort={(sortData) =>
                                            handleSort(sortData)
                                        }
                                        sort={tableConfig?.sort}
                                    fields={fields}
                                    hasCheckbox={true}
                                    showSelectAll={true}
                                    checkBoxSelectedFieldName="id"
                                    actions={actions}
                                    stickyHeader
                                />
                            </Loadable>
                        </div>
                    </PortletBody>
                </Portlet>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained">
                    Cancel
                </Button>
                <Button 
                    onClick={handleImport} 
                    color="primary" 
                    variant="contained" 
                    disabled={selectedItems.length === 0}
                >
                    Import
                </Button>
            </DialogActions>
        </Dialog>
    );
}
